import "./Footer.css";
import { useLanguage } from "./LanguageContext";
import SmoothScrollLink from "./SmoothScrollLink"; // aggiorna il path se necessario

const Footer = () => {
  const { t } = useLanguage();

  // se hai un header sticky, metti l'altezza qui (px)
  const stickyHeaderHeight = 70; // adattalo se hai header sticky

  return (
    <footer className="text-white py-5">
      <div className="container">
        <div className="row g-4">
          {/* Logo e slogan */}
          <div className="col-12 col-md-4 d-flex flex-column align-items-center">
            <SmoothScrollLink
              to="Header"
              offset={stickyHeaderHeight}
              className="navbar-brand fw-bold d-flex align-items-center"
              style={{ fontSize: "30px", textDecoration: "none", color: "inherit" }}
            >
              <img
                src="https://res.cloudinary.com/dtem45qog/image/upload/v1748428194/senza_sfondo_tyd5vs.png"
                alt="Logo"
                style={{ height: "60px", marginRight: "10px" }}
              />
              Thirdiograpy
            </SmoothScrollLink>

            <p>{t("footerSlogan")}</p>
          </div>

          {/* Link utili */}
          <div className="col-12 col-md-4">
            <h6 className="fw-semibold mb-2">{t("footerLinksTitle")}</h6>
            <ul className="list-unstyled footer-links">
              <li>
                <SmoothScrollLink to="HeroSection" offset={stickyHeaderHeight}>
                  {t("Homepage") || "Homepage"}
                </SmoothScrollLink>
              </li>
              <li>
                <SmoothScrollLink to="CommentCarousel" offset={stickyHeaderHeight}>
                  {t("navDicono") || "Dicono di me"}
                </SmoothScrollLink>
              </li>
              <li>
                <SmoothScrollLink to="ContactFAQ" offset={stickyHeaderHeight}>
                  {t("navContattami") || "Contact"}
                </SmoothScrollLink>
              </li>
            </ul>
          </div>

          {/* Contatti */}
          <div className="col-12 col-md-4">
            <h6 className="fw-semibold mb-2">{t("footerContactTitle")}</h6>
            <p className="mb-1">{t("footerPhone")}</p>
            <p>{t("footerEmail")}</p>

            {/* Icone social */}
            <div className="social-icons mt-2">
              <a
                href="https://www.instagram.com/thirdiograpy/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src="https://cdn.jsdelivr.net/gh/simple-icons/simple-icons/icons/instagram.svg"
                  alt="Instagram"
                  style={{ width: "24px", height: "24px", marginRight: "10px" }}
                />
              </a>
              <a
                href="https://www.linkedin.com/in/simone-terzi-57a92a184/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src="https://cdn.jsdelivr.net/gh/simple-icons/simple-icons/icons/linkedin.svg"
                  alt="LinkedIn"
                  style={{ width: "24px", height: "24px" }}
                />
              </a>
            </div>
          </div>
        </div>

        <div className="text-center mt-4 small">{t("footerCopyright")}</div>
      </div>
    </footer>
  );
};

export default Footer;
